import React from 'react';
import PropTypes from 'prop-types';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import { CPButton } from '../../../components/bootStrap/buttons';
import { ButtonCollapse } from '../../../components/bootStrap/buttons/buttonCollapse';

export function HideButton({ content, onClick, disabled }) {
  return (
    <ButtonCollapse>
      <CPButton
        onClick={onClick}
        disabled={disabled}
        title={content}
        icon={faSort}
        content=""
      />
    </ButtonCollapse>
  );
}

HideButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

HideButton.defaultProps = {
  onClick: () => null,
  content: 'Згорнути/Розгорнути',
  disabled: false,
};

export default HideButton;
